// extracted by mini-css-extract-plugin
module.exports = {"orderHistory":"Xk","header":"Yk","desktopOrderHistory":"Zk","mobileOrderHistory":"_k"};